module.exports = __webpack_public_path__ + "assets/c7b047dc00e09be0b8c248e4583c5758.png";